var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13L1 12.25C1 12.25 1 10 1.75 7.75C2.5 5.5 7.75 5.5 7.75 5.5M4 13L7 16M4 13C4 13 7 5.5 10.75 3.25C14.5 1 19 1 19 1C19 1 19 5.5 16.75 9.25C14.5 13 7 16 7 16M7 16L7.75 19C7.75 19 10 19 12.25 18.25C14.5 17.5 14.5 12.25 14.5 12.25",
    stroke: "#141414",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/defaultIcon.9c2ac4eec943042ac697227155d4e8b1.svg";
export { ForwardRef as ReactComponent };